import {getPrimaryAccount} from '../../../utils/sessionUtil'
import { getpwUrl } from '../../../utils/commonUtil';
 
export const getTransactionApi = (data) => {
    const individualYears = data.selectedVal.length === 0 || data.selectedVal[0] === "All" || data.selectedVal[0].indexOf('Custom Dates') !== -1 ? false : data.selectedVal.join();
    const shouldNotStartDate = ((data.selectedVal && data.selectedVal.length === 0) || (data.selectedVal && data.selectedVal.length === 1 && data.selectedVal[0] === 'All'))
    return [
      {
        method: "GET",
        url: `/donor-portal/api/account/${getPrimaryAccount().userId}/findTransactionSummaryDetails?startDateStr=${ shouldNotStartDate ? '' : data.startDate}&endDateStr=${data.endDate}&isTradeDate=${data.isTradeDate}&type=${data.type}`,//As for Siva comment on issue OW-311, we are not passing start date
        tabType: data.type
      },
      {
        method: "GET",
        url: `/donor-portal/api/account/${getPrimaryAccount().userId}/findInvestmentOptionBalanceDetails?startDateStr=${data.startDate}&endDateStr=${data.endDate}${individualYears ? `&individualYears=${individualYears}` : ''}`//end to change endDate to todayDate and add type
      },
      {
        method: "GET",
        url: `/donor-portal/api/account/${getPrimaryAccount().userId}/findFeeAndExpensesByAccountId?startDateStr=${data.startDate}&endDateStr=${data.endDate}`//end to change endDate to todayDate and add type
      },
      {
        method: "GET",
        url: `/fees-and-expenses`
      }
    ]
}

